

export const getConfigFn=(callBack)=>{
    // if(!window.sessionStorage.getItem('setConfig')){
    //     let ajax = new XMLHttpRequest()      // 创建ajax对象
    //     ajax.open("GET",process.env.BASE_URL+'/admin/sys/loginConfig');
    //     ajax.send()
    //     ajax.onreadystatechange=function(){  //  请求响应
    //         if(ajax.readyState == 4 && (ajax.status == 200 || ajax.status == 304)){
    //             let res=JSON.parse(ajax.responseText||'{}');
    //             console.log(res)
    //             let use=res.use;
    //             let config=res.data.data;
    //             let obj={...config[use],currentUse:use};
    //             callBack&&callBack(obj);
    //             window.sessionStorage.setItem('setConfig',JSON.stringify(obj));
    //             let faviconLink= document.querySelector('#faviconLink');
    //             if(faviconLink){
    //                 faviconLink.setAttribute("href", process.env.BASE_URL + obj.favicon);
    //             }
    //         }
    //     }}
    // }else{
    //     let res=JSON.parse(window.sessionStorage.getItem('setConfig'));
    //     callBack&&callBack(res);
    // }
    let faviconLink = document.querySelector("#faviconLink");
    if (faviconLink && JSON.parse(window.sessionStorage.getItem("setConfig"))) {
      faviconLink.setAttribute(
        "href",
        JSON.parse(window.sessionStorage.getItem("setConfig")).favicon
      );
    }
}


